import script from "./Look_Task.vue?vue&type=script&setup=true&lang=js"
export * from "./Look_Task.vue?vue&type=script&setup=true&lang=js"

import "./Look_Task.vue?vue&type=style&index=0&id=a80983ea&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a80983ea"]])

export default __exports__